import { toJpeg } from 'html-to-image';

export const saveChartsAsJpeg = async (className: string): Promise<void> => {
  const node = document.querySelector(`.${className}`) as HTMLElement | null;

  if (!node) {
    console.error('Element not found');
    return;
  }

  try {
    const dataUrl = await toJpeg(node, { backgroundColor: '#ffffff' });

    const link = document.createElement('a');
    link.download = 'chart.jpeg';
    link.href = dataUrl;
    link.click();
  } catch (err) {
    console.error('Failed to export image', err);
  }
};
